<template>
  <span>
    <slot
      :disabled="false"
      :onClick="onShow"
      :isExist="isExist"
    />
  </span>
</template>

<script>

export default {
  inject: ['$validator'],
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isExist() {
      return !!this.room.contact
    },
  },
  methods: {
    onShow() {
      this.$store.commit('addContact/SET_ROOM', this.room);
    },
  },
};
</script>

<style scoped>

</style>
